import { REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'

export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectProspectList = state => {
    return selectOwnState(state).prospectList
}

export const selectIsFetching = state => {
    return selectOwnState(state).fetching
}



// WEBPACK FOOTER //
// ./src/modules/prospect/state/search/selector.js